export default __webpack_public_path__ + "static/media/big-launch.7441042d.svg";